import Vue from 'vue'
// @ts-ignore
import { StripeCheckout } from '@vue-stripe/vue-stripe'

export default () => {
  Vue.component('StripeCheckout', StripeCheckout)
}
